export type FlowDirection = 'in' | 'out'

/** Vocabulário conhecido de entrada, alinhado com o mapeamento de rótulos em
 *  `dashboard/utils/notification-utils.tsx#getDirection` — o valor bruto que a
 *  câmera manda varia (reverse/forward, in/out, enter...). Qualquer valor fora
 *  desse conjunto é tratado como saída. */
const ENTRY_VALUES = new Set([
  'reverse',
  'in',
  'enter',
  'incoming',
  'entrance',
  'entry',
])

export const classifyDirection = (direction: string): FlowDirection =>
  ENTRY_VALUES.has(direction.toLowerCase()) ? 'in' : 'out'
